import type { ButtonColourScheme } from "./types"

export const DEFAULT_ELEMENT = "button" as const

// These classes should be given to all buttons
export const BASE_CLASSES = "transition-all border-2 font-medium box-border inline-block"
export const BASE_CLASSES_MD = "min-h-11 rounded-lg px-6 text-base leading-6"
export const BASE_CLASSES_SM = "min-h-8 rounded-md px-4 text-sm leading-4"
export const BASE_CLASSES_ENABLED = "cursor-pointer"
export const BASE_CLASSES_DISABLED = "cursor-not-allowed"
export const BASE_CLASSES_ACTIVE = "active:translate-y-[2px]"
export const BASE_CLASSES_FOCUS = "focus-visible:ring-4"

export const COLOUR_SCHEMES: ButtonColourScheme = {
  primary: "bg-primary-base border-primary-base text-white",
  secondary: "bg-white border-primary-base text-primary-base",
  outline: "bg-white border-gray-300 text-black",
  borderless: "bg-transparent border-transparent text-primary-darken-100",
  danger: "bg-error-base border-error-base text-white",
  "danger--outline": "bg-white border-error-base text-error-base",
  "danger--borderless": "bg-white border-white text-error-base",
}

export const COLOUR_SCHEMES_HOVER: ButtonColourScheme = {
  primary: "hover:bg-primary-darken-100 hover:border-primary-darken-100",
  secondary: "hover:bg-primary-lighten-100",
  outline: "hover:bg-gray-100",
  borderless: "hover:bg-gray-100",
  danger: "hover:bg-error-darken-100 hover:border-error-darken-100",
  "danger--outline": "hover:bg-gray-100",
  "danger--borderless": "hover:bg-gray-100",
}

export const COLOUR_SCHEMES_DISABLED: ButtonColourScheme = {
  primary: "bg-primary-lighten-50 border-transparent",
  secondary: "border-primary-lighten-50 text-primary-lighten-50",
  outline: "border-gray-200 text-gray-300",
  borderless: "bg-transparent text-primary-lighten-50",
  danger: "bg-error-lighten-50 border-error-lighten-50",
  "danger--outline": "text-error-lighten-50 border-error-lighten-50",
  "danger--borderless": "text-error-lighten-50",
}
